import { createTheme, Theme, ThemeOptions } from "@mui/material";

export enum Palette_Mode {
    DARK = "dark",
    LIGHT = "light",
}

const common_theme_options: ThemeOptions = {
    components: {
        MuiButton: { defaultProps: { size: "small" } },
        MuiTextField: { defaultProps: { size: "small" } },
    },
};

export const dark_theme = createTheme({
    ...common_theme_options,
    palette: {
        mode: "dark",
        primary: {
            main: "#fcca4a",
        },
    },
});

export const light_theme = createTheme({
    ...common_theme_options,
    palette: {
        mode: "light",
        primary: {
            main: "#fcca4a",
        },
    },
});
